import { render } from "./AlarmRequestPermissionPropsCmp.vue?vue&type=template&id=c4a69194"
import script from "./AlarmRequestPermissionPropsCmp.vue?vue&type=script&lang=js"
export * from "./AlarmRequestPermissionPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__